import { useAuthStore } from '../../store/authStore';
import { useContextStore } from '../../store/contextStore';
import { useProductStore } from '../../store/productStore';

export const ReservedContexts = ['serviceProvider', 'meta'];

const resolution = {
  context: {
    getAvailable: () => useAuthStore().token?.contexts ?? [],
    getLatest: () => useContextStore().latestContextId
  },
  product: {
    getAvailable: () => useContextStore().organization?.enabledProducts ?? [],
    getLatest: () => useProductStore().latestProductId
  }
};

export function resolveContext(contextId?: string): string | undefined {
  const contexts = resolution.context
    .getAvailable()
    .filter((it) => !ReservedContexts.includes(it));

  if (contexts.length === 0) {
    console.warn(`[RESOLVER] User not invited to any context`);
    return undefined;
  }
  if (contextId && !contexts.includes(contextId)) {
    console.warn(`[RESOLVER] User not invited to '${contextId}'`);
    return undefined;
  }

  const latest = resolution.context.getLatest() ?? '';
  const first = contexts[0];

  const candidates = [contextId, latest, first];
  return candidates.find((it) => contexts.includes(it ?? ''));
}

export function resolveProduct(productId?: string): string | undefined {
  const products = resolution.product.getAvailable();
  if (products.length === 0) {
    console.warn(`[RESOLVER] No product enabled`);
    return undefined;
  }

  if (productId && !products.includes(productId)) {
    console.warn(`[RESOLVER] Product '${productId}' is not enabled`);
    return undefined;
  }

  const latest = resolution.product.getLatest();
  const first = products[0];

  const candidates = [productId, latest, first];
  return candidates.find((it) => products.includes(it ?? ''));
}
